import { useRef } from 'react';
import type { ViewInstance } from 'react-native';

// Stubbed version for web
export const useKeyboardAvoiderScroll = (_isFocused: boolean) => {
  const avoiderRef = useRef<ViewInstance>(null);

  return { avoiderRef };
};

// Stubbed version for web
export const useKeyboardAvoiderPadding = () => {
  return { keyboardPadding: null };
};
